module.exports = __webpack_public_path__ + "img/42.0e66118e.jpg";